// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"UsersTable_stickyHeader_3O5zP","q-table__top":"UsersTable_q-table__top_LKucZ","q-table__bottom":"UsersTable_q-table__bottom_1-3XO"};